import React from 'react';
import theme from '../styles/theme';

const NarwhalLogo = ({ className }) => {
  return (
    <svg 
      className={className || "w-12 h-12 md:w-16 md:h-16"} 
      viewBox="0 0 800 800" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M400 0C400 0 400 220 400 400C400 400 220 400 400 400C490 400 580 490 400 580C270 640 130 490 130 400C130 220 220 130 400 130C580 130 670 220 670 400C670 580 580 670 400 670C220 670 130 580 130 400" 
        stroke={theme.colors.azul} 
        strokeWidth="50" 
        fill="none"
      />
    </svg>
  );
};

export default NarwhalLogo;
